/**
 * TanStack Query client configuration.
 *
 * Global defaults are conservative — feature queries override as needed.
 * Stale time: 2 minutes (most admin data changes infrequently)
 * Retry: 2 times for network errors; 0 times for 4xx (client errors don't recover)
 */

import { QueryClient } from "@tanstack/react-query";
import type { ApiError } from "@/types/api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,      // 2 minutes
      gcTime: 10 * 60 * 1000,         // 10 minutes
      refetchOnWindowFocus: false,     // Admin users switch tabs frequently
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        const apiError = error as unknown as ApiError;
        // Don't retry 4xx client errors
        if (apiError?.code?.startsWith("not_found")) return false;
        if (apiError?.code?.startsWith("authz.")) return false;
        if (apiError?.code?.startsWith("validation.")) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: 0, // Never retry mutations automatically
    },
  },
});
